export default "__VITE_ASSET__ff241379__"